var render = function render(){var _vm=this,_c=_vm._self._c;return _c('question-editor',{attrs:{"faq-id":_vm.faq.id,"category-id":_vm.categoryId,"subcategory-id":_vm.subcategoryId,"categories":_vm.faq.categories,"subcategories":_vm.faq.subcategories,"open-ai-description":_vm.faq.openai_description,"errors":_vm.errors,"mode":"create"}})
}
var staticRenderFns = []

export { render, staticRenderFns }